import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FileUploadComponent } from './file-upload.component';
import { FileDropModule } from 'angular2-file-drop';
import { FormsModule } from '@angular/forms';

@NgModule({
    imports: [
        CommonModule,
        FileDropModule,
        FormsModule
    ],
    exports: [
        FileUploadComponent
    ],
    declarations: [FileUploadComponent]
})
export class FileUploadModule { }



// WEBPACK FOOTER //
// /app/src/app/components/file-upload/file-upload.module.ts